import { render } from "./dynamicdashboard.vue?vue&type=template&id=0d72bc17&scoped=true"
import script from "./dynamicdashboard.js?vue&type=script&lang=js"
export * from "./dynamicdashboard.js?vue&type=script&lang=js"

import "./dynamicdashboard.vue?vue&type=style&index=0&id=0d72bc17&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d72bc17"]])

export default __exports__